import { render, staticRenderFns } from "./QuickActionBar.vue?vue&type=template&id=2a242b1a&"
import script from "./QuickActionBar.vue?vue&type=script&lang=ts&"
export * from "./QuickActionBar.vue?vue&type=script&lang=ts&"
import style0 from "./QuickActionBar.vue?vue&type=style&index=0&id=2a242b1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports